/**
 * Shared development environment — the default environment file.
 *
 * Used by the default `ng serve client` / `ng build client` and the client
 * `dev` build configuration (the deployed dev build). Served from the shared
 * dev frontend domains (Heron and tenants 1-3), or locally from
 * localhost:4300 — both resolve the tenant — API origin and advisor app URL —
 * at runtime from the browser origin against `tenant-routes/dev.ts`, whose
 * localhost row points local serving at the shared dev API. To run against a
 * locally running backend instead, use the `local` configuration
 * (scripts/start-local-fullstack.sh).
 */

import { apiUrlsFromOrigin, resolveFrontendRoutes } from '../../../../tenant-routes/tenant-frontend-routing';
import { DEV_TENANT_ROUTES } from '../../../../tenant-routes/dev';

const frontendRoutes = resolveFrontendRoutes(window.location.origin, DEV_TENANT_ROUTES);
const apiUrls = apiUrlsFromOrigin(frontendRoutes.apiOrigin);

export const environment = {
  production: false,
  apiUrl: apiUrls.apiUrl,
  apiVersion: '/v1/',
  rawApiUrl: apiUrls.rawApiUrl,

  adminWebUrl: frontendRoutes.advisorFrontendUrl,
  tenantId: frontendRoutes.tenantId ?? frontendRoutes.brandId ?? null,
  brandId: frontendRoutes.brandId ?? null,
  internalIntroducerLink: 'heron',

  officePhone: '+44 (0)203 195 1982',
  officePhoneLink: 'tel:+442031951982'
};
